import React, { useContext } from 'react'
import StateContext from '../../StateContext';

import CardImage from '../ReusableComponents/CardImage';

function HomeCardRecipe() {

    const appState = useContext(StateContext)

    return (
        <>
        <div className="container">
            <div className="row my-3">
                <div className="col-md-4 mb-2">
                    <CardImage 
                        imageUrl="https://camillahardilla.com/wp-content/uploads/2020/02/flat-lay-photography-of-vegetable-salad-on-plate-1640777-1024x683.jpg" 
                        cardTitle="Oppskrifter"
                        cardDescription="Siste oppskrifter fra brukere"
                        btnText="Vis innlegg"
                        cardLink="/innlegg/1"
                        btnColor="primary"
                    />
                </div>
                <div className="col-md-4 mb-2">
                    <CardImage 
                        imageUrl="https://camillahardilla.com/wp-content/uploads/2020/07/appetizing-pancakes-served-on-tray-with-sauces-4514085.jpg" 
                        cardTitle="Categories"
                        cardDescription="Shows categories"
                        btnText="Show categories"
                        cardLink="/categories"
                        btnColor="warning"
                    />
                </div>                
                <div className="col-md-4 mb-2">
                    <CardImage 
                        imageUrl="https://camillahardilla.com/wp-content/uploads/2020/07/adventure-backlit-dawn-dusk-207896-scaled.jpg" 
                        cardTitle="Min profil"
                        cardDescription="Knytt kontakt med andre i samfunnet"
                        btnText="Vis min profil"
                        cardLink={`/member/${appState.userId}`}
                        btnColor="success"
                    />
                </div>
            </div>
        </div>
        </>
    )
}
export default HomeCardRecipe